/**
 * @file: displayChassisNo.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { kNullVIN } from '@euler/functions/constants';

/**
 * The number that belongs under a 车架号 label. A vehicle with no ISO VIN
 * carries the placeholder in `vin` and its real chassis number beside it, so
 * showing `vin` unconditionally would put a row of zeros on screen.
 */
export const displayChassisNo = (vehicle: {
  vin: string | null | undefined;
  chassisNo?: string | null;
}): string =>
  vehicle.vin === kNullVIN ? vehicle.chassisNo ?? '' : vehicle.vin ?? '';
